export const howItWorksGenerate = [
	{
		icon: '👩‍💻',
		title: 'howItWorksData_title1',
		subtitle: 'howItWorksData_subtitle1',
	},
	{
		icon: '👩‍🎤',
		title: 'howItWorksData_title2',
		subtitle: 'howItWorksData_subtitle2',
	},
	{
		icon: '🖼',
		title: 'howItWorksData_title3',
		subtitle: 'howItWorksData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'howItWorksData_title4',
		subtitle: 'howItWorksData_subtitle4',
	},
];
